import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  select: {
    minWidth: 120,
    maxWidth: 190,
  },
}));

// Estética unificada de filtros (misma que el filtro "Estado...").
const filterSelectStyle = {
  fontSize: 11,
  height: 22,
  border: "1px solid rgba(0,0,0,0.18)",
  borderRadius: 10,
  padding: "0 4px",
  background: "transparent",
  opacity: 0.7,
};

const TicketsContactTypeSelect = ({
  userContactTypes = [],
  selectedContactTypeIds = [],
  onChange,
}) => {
  const classes = useStyles();

  if (!userContactTypes || userContactTypes.length === 0) return null;

  const buildLabel = () => {
    if (selectedContactTypeIds.length === 0) {
      return i18n.t("ticketsList.filters.contactTypePlaceholder");
    }
    if (selectedContactTypeIds.length === 1) {
      const ct = userContactTypes.find(t => t.id === selectedContactTypeIds[0]);
      return ct ? ct.name : "1";
    }
    return i18n.t("ticketsList.filters.contactTypeCount", { count: selectedContactTypeIds.length });
  };

  const handleToggle = (id) => {
    const newIds = selectedContactTypeIds.includes(id)
      ? selectedContactTypeIds.filter(i => i !== id)
      : [...selectedContactTypeIds, id];
    onChange(newIds);
  };

  return (
    <FormControl size="small" className={classes.select}>
      <Select
        multiple
        value={[]}
        displayEmpty
        disableUnderline
        renderValue={() => (
          <span style={{ fontSize: 11 }}>{buildLabel()}</span>
        )}
        style={filterSelectStyle}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: { style: { maxHeight: 320 } },
        }}
        inputProps={{ style: { padding: "0 4px", fontSize: 11 } }}
      >
        {userContactTypes.map(ct => (
          <MenuItem dense key={ct.id} onClick={() => handleToggle(ct.id)}>
            <Checkbox
              size="small"
              checked={selectedContactTypeIds.includes(ct.id)}
              style={{ color: ct.color || "#667eea" }}
            />
            <span
              style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: ct.color || "#667eea",
                marginRight: 6,
                flexShrink: 0,
              }}
            />
            <ListItemText
              primary={ct.name}
              primaryTypographyProps={{ style: { fontSize: 13 } }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TicketsContactTypeSelect;
